import axios from 'axios';
import { BASE_URL } from '../config/config';

// const URL = 'http://localhost:3000/business-units';
const URL = BASE_URL + '/business-units';

const getBusinessUnitList = async (keyword, page, limit) => {
  try {
    const response = await axios.get(URL, {
      params: {
        keyword,
        page,
        limit,
      },
    });
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

const createBusinessUnit = async (data) => {
  try {
    const result = await axios.post(URL, data);
    return result.data;
  } catch (error) {
    if (error.response && error.response.data && error.response.data.message) {
      throw new Error(error.response.data.message); // Lempar kesalahan jika ada
    } else {
      throw new Error('There was an error creating the business unit.');
    }
  }
};

const updateBusinessUnit = async (id, data) => {
  try {
    await axios.put(`${URL}/${id}`, data);
  } catch (error) {
    console.log(error);
  }
};

const deleteBusinessUnit = async (id) => {
  try {
    await axios.delete(`${URL}/${id}`);
  } catch (error) {
    console.log(error);
  }
};

const getBusinessUnitById = async (id) => {
  try {
    const result = await axios.get(`${URL}/${id}`);
    return result.data;
  } catch (error) {
    console.log(error);
  }
};

export {
  getBusinessUnitList,
  createBusinessUnit,
  updateBusinessUnit,
  deleteBusinessUnit,
  getBusinessUnitById,
};
